/**
 * 서버 에러 코드 타입 정의
 * 5xx 에러 코드를 명시적으로 타입화
 */
type ServerErrorCode = 500 | 501 | 502 | 503 | 504 | 505

/**
 * 서버 에러 메시지 맵핑 객체
 * 각 에러 코드별 메시지 제공
 */
export const SERVER_ERROR_MESSAGES: Record<
    ServerErrorCode,
    { title: string; description: string }
> = {
    500: {
        title: '일시적인 문제가 발생했어요',
        description:
            '잠시 후 다시 시도하거나, \n 지속적으로 발생한다면 클릭메이트 고객센터로 문의해주세요.',
    },
    501: {
        title: '아직 준비중인 기능이에요',
        description: '곧 만나보실 수 있도록 빠르게 준비할게요!',
    },
    502: {
        title: '서비스 연결이 불안정해요',
        description:
            '빠르게 복구 중이니 잠시 후 다시 이용해 주세요.\n문제가 지속된다면 클릭메이트 고객센터로 문의해 주세요.',
    },
    503: {
        title: '서비스 접속이 원활하지 않아요',
        description:
            '빠르게 복구 중이니 잠시 후 다시 이용해 주세요.\n문제가 지속된다면 클릭메이트 고객센터로 문의해 주세요.',
    },
    504: {
        title: '요청을 처리하지 못했어요',
        description:
            '일시적인 지연일 수 있으니 잠시 후 다시 이용해 주세요.\n문제가 지속된다면 네트워크 상태를 확인하거나, 클릭메이트 고객센터로 문의해 주세요.',
    },
    505: {
        title: '이 요청은 현재 서비스에서 지원되지 않아요',
        description: '문제가 지속된다면 클릭메이트 고객센터로 문의해주세요.',
    },
} as const

/**
 * 에러 코드에 해당하는 사용자 메시지를 반환하는 함수
 * @param errorCode - 서버에서 반환된 에러 코드
 * @returns 사용자에게 표시할 에러 메시지 객체 또는 기본 에러 메시지
 */
export const getServerErrorMessage = (
    errorCode: string | null
): { title: string; description: string } | null => {
    const errorCodeNumber = Number(errorCode)
    if (errorCodeNumber && errorCodeNumber >= 500 && errorCodeNumber <= 505) {
        return SERVER_ERROR_MESSAGES[errorCodeNumber as ServerErrorCode]
    }

    // 5xx 에러 코드가 아닌 경우 null 반환
    return null
}

/**
 * 서버 에러 코드 타입 정의
 */
export const protectedServerError = (errorCode: string) => {
    const errorCodeNumber = Number(errorCode)
    return errorCodeNumber && errorCodeNumber >= 500 && errorCodeNumber <= 505
}
